<template>
     <!-- <keep-alive> -->
      <component  v-bind:is="layout"></component>
    <!-- </keep-alive> -->
</template>

<script>
import AppLayout from './views/layouts/AppLayout'
import SimpleLayout from './views/layouts/SimpleLayout'
import ErrorLayout from './views/layouts/ErrorLayout'

const cloneDeep = require('clone-deep');

export default {
   data() {
      return {
        renderComponent: true,
      };
    },
  components:{
    'app-layout': AppLayout,
    'simple-layout': SimpleLayout,
    'error-layout': ErrorLayout 
  },
  computed: {
    watch_states(){
      return cloneDeep(this.$store.getters.layout)
    },
    layout () {
      return this.$store.getters.layout
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
    showAdminBoard() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes('ROLE_ADMIN');
      }

      return false;
    },
    showModeratorBoard() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes('ROLE_MODERATOR');
      }

      return false;
    }
  },
  methods: {
    logOut() {
      this.$store.dispatch('auth/logout');
      this.$router.push('/login');
    }
  },
  watch:{
    watch_states(newValue,oldValue) {
      /* console.warn(newValue,oldValue);*/
    }
     
  }
};
</script>

<style >
.panel .panel-body{
  font-size:14px;
}
body{
  font-size:14px;
}
.enquiry-btn{
    margin-right: 10px !important;
}

input.form-control {
    font-size: 14px;
}

.vdp-datepicker input {
    border-bottom: solid 1px #ccc;
    width: 100%;
    border-top: none;
    border-left: none;
    border-right: none;
    padding-bottom: 6px;
}


.bg-loginimg button {
    background: #03a9f4;
    border: none;
    color: #fff !important;
    padding: 7px;
    font-size: 16px;
}

.bg-loginimg button:hover {
    background: #51b7e5!important;
}
</style>
